import { lazy } from 'react';

export const EpisodeDetailPage = lazy(() =>
  import('./episode-detail.page').then((m) => ({ default: m.EpisodeDetailPage }))
);
